import { __decorate, __metadata } from "tslib";
import { MEDIA_PROPS_ACCESSOR, MEDIA_PROPS_EDITORDEF, MediaAssets } from '@common/media/shared';
import { UseRestraints } from '@core/shared/restraints';
import { AllowHtml, CrudEndpoints, EditorDefinition, Expose, IdItemModel, IsBoolean, IsNotNull, IsNumber, ItemModelDefinition, ItemModelProp, MinLength, ModelId, Structure, Trim, ValidateNested } from '@core/shared/model';
import { QuestionAttachmentItem } from './question-attachment.item';
import { QuestionRestraints } from './question.restraints';
let QuestionItem = /*#__PURE__*/(() => {
  let QuestionItem = class QuestionItem extends IdItemModel {
    // NOTE: duration cannot be calculated in subscriber.afterLoad, because media data will be fetched in its own subscriber.afterLoad.
    toString() {
      return "Question " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], QuestionItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], QuestionItem.prototype, "updateDate", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], QuestionItem.prototype, "enabled", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], QuestionItem.prototype, "teaser", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], QuestionItem.prototype, "hasAccess", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], QuestionItem.prototype, "highlight", void 0);
  __decorate([MinLength(3), Expose(), Trim(), ItemModelProp({
    defaultValueCreate: '',
    isOptionalUpdate: false
  }), __metadata("design:type", String)], QuestionItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), AllowHtml(), __metadata("design:type", String)], QuestionItem.prototype, "description", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), AllowHtml(), __metadata("design:type", String)], QuestionItem.prototype, "transcript", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", String)], QuestionItem.prototype, "mandatoryNote", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }) // defaulting to null will make sure isNotNull validator triggers correctly
  , IsNumber({}, {
    message: 'Bitte wählen Sie eine Kategorie'
  }), IsNotNull(), __metadata("design:type", Number)], QuestionItem.prototype, "categoryId", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], QuestionItem.prototype, "category", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Array)], QuestionItem.prototype, "tags", void 0);
  __decorate([Expose(), Structure(Array, () => QuestionAttachmentItem), ValidateNested(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Array)], QuestionItem.prototype, "attachments", void 0);
  __decorate([Expose(), ValidateNested(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Array)], QuestionItem.prototype, "_attachments", void 0);
  QuestionItem = __decorate([EditorDefinition('admin', {
    enabled: true,
    teaser: true,
    highlight: true,
    name: true,
    thumbnail: true,
    transcript: true,
    description: true,
    tags: true,
    categoryId: true,
    [MEDIA_PROPS_ACCESSOR]: MEDIA_PROPS_EDITORDEF
  }, {
    useCrudEndpoint: 'admin'
  }), EditorDefinition('admin-attachments', {
    attachments: {
      loadDefinition: 'admin-attachments'
    }
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    public: '/questions',
    admin: '/admin/questions'
  }), UseRestraints(QuestionRestraints), ItemModelDefinition({
    texts: {
      item: 'Frage',
      items: 'Fragen',
      newItem: 'Neue Frage erstellen'
    }
  }), MediaAssets(['thumbnail', 'video']), ModelId("QuestionItem") // auto-generated by generate-model-ids
  ], QuestionItem);
  return QuestionItem;
})();
export { QuestionItem };